// extracted by mini-css-extract-plugin
export var cardIcon = "_3y-4";
export var checkboxCard = "_3y-0";
export var checkboxCardSelected = "_3y-1";
export var disabled = "_3y-2";
export var outerBorder = "_3y-3";
export var spacerMedium = "_3y-7";
export var spacerSmall = "_3y-6";
export var spacerXsmall = "_3y-5";